export interface SkeletonTextLoadingProps {
  rows: number;
}

export const SkeletonTextLoading = ({ rows }: SkeletonTextLoadingProps) => {
  return (
    <div className="flex flex-col gap-5 p-4 border border-ds-natural-150 rounded-lg">
      {Array.from({ length: rows }).map((_, index) => (
        <div
          key={index}
          className="bg-ds-accent3-100 rounded-md animate-pulse flex flex-col gap-2"
        >
          <div className="w-full h-7 bg-ds-natural-50 rounded-md" />
          <div className="w-3/4 h-7 bg-ds-natural-50 rounded-md" />
          <div className="w-1/2 h-7 bg-ds-natural-50 rounded-md" />
        </div>
      ))}
    </div>
  );
};
